import React from 'react'
import { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { ResidentAppError } from '../../../common/error'

import { Error } from 'components/Error'
import { ResidentAppErrorBoundary } from 'components/ResidentAppErrorBoundary/ResidentAppErrorBoundary'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const [t] = useTranslation(['bulletins'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        default:
      }
    }

    return <Error message={t('errors.errorLoadingBulletin')} />
  }

  return (
    <ResidentAppErrorBoundary fallbackRender={fallbackRender}>
      {children}
    </ResidentAppErrorBoundary>
  )
}
